import React from "react";

import profileIcon from "images/profile-icon.svg";

const ProfileIcon = () => <img src={profileIcon} alt="Profile Icon" />;

export default ProfileIcon;
